module.exports = __webpack_public_path__ + "img/0Q3B7497_Black.86e0770d.jpg";